import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiHandler, Handler, HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    AddWishListResult,
    CallAddWishListApi,
    chain,
} from "@insite/client-framework/Store/Pages/MyLists/Handlers/AddWishList";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import { AddWishListApiParameter, CustomaddWishList } from "@tSchaedlerYesco/Services/MyListBranchService";

type HandlerType = HandlerWithResult<
    {
        apiParameter: AddWishListApiParameter;
        reloadWishLists?: boolean;
        onSuccess?: (addedWishList: WishListModel) => void;
        onError?: (errorMessage: string) => void;
    },
    AddWishListResult
>;

export const CustomCallAddWishListApi: HandlerType = async props => {
    try {
        props.result.wishListModel = await CustomaddWishList(props.parameter.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.result.errorMessage = error.errorJson.message;
            return;
        }
        throw error;
    }
};

replaceInChain(chain, CallAddWishListApi, CustomCallAddWishListApi);
